interface PropsType {
  style?: React.CSSProperties;
  color?: string;
}

const SmartphoneWifiIcon = (props: PropsType) => {
  return (
    <svg width="28" height="28" viewBox="0 0 28 28" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path
        d="M9.33334 6.99992C7.43517 7.03492 6.34434 7.19592 5.60584 7.94725C4.66667 8.90392 4.66667 10.4451 4.66667 13.5274V19.1298C4.66667 22.2109 4.66667 23.7521 5.60584 24.7099C6.54617 25.6666 8.05817 25.6666 11.0833 25.6666C14.1085 25.6666 15.6217 25.6666 16.5608 24.7099C17.5 23.7521 17.5 22.2109 17.5 19.1298V15.7453M11.0833 22.1666H11.0938M11.6667 4.48809C13.342 3.12659 15.3428 2.33325 17.4918 2.33325C19.6478 2.33325 21.6545 3.13009 23.3333 4.50092M20.671 8.16659C19.721 7.56074 18.6186 7.23708 17.4918 7.23325C16.3555 7.23325 15.281 7.56692 14.3278 8.15725M17.5 11.6666H17.507"
        stroke="white"
        strokeWidth="2.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
};

export default SmartphoneWifiIcon;
